// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar
  Layout only. Tokens and ui-* classes come from siteShell.css. 
*/

.navbar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: saturate(180%) blur(12px);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
  border-bottom: 1px solid var(--border);
}

@supports not (backdrop-filter: blur(12px)) {
  .navbar {
    background: var(--bg);
  }
}

.navbar-inner {
  position: relative;
  width: 100%;
  max-width: var(--container);
  margin: 0 auto;
  padding: 0 var(--gutter);
  min-height: 54px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: var(--space-4);
}

/* Logo */
.navbar-logo {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-height: 40px;
  color: var(--primary);
  text-decoration: none;
}

.navbar-logo-img {
  width: 30px;
  height: 30px;
  display: block;
}

.navbar-logo-text {
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.018em;
  white-space: nowrap;
}

/* Desktop navigation */
.navbar-nav {
  display: none;
  justify-content: center;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}

.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 6px 11px;
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.4;
  color: var(--text-secondary);
  text-decoration: none;
  white-space: nowrap;
  border-radius: var(--radius-sm);
  transition:
    color var(--dur-fast) var(--ease-standard),
    background-color var(--dur-fast) var(--ease-standard);
}

.nav-link:hover {
  color: var(--text-primary);
  background: var(--bg-secondary);
}

.nav-link.is-active,
.nav-link[aria-current='page'] {
  font-weight: 700;
  color: var(--primary);
  background: var(--surface-brand-wash);
}

/* Right-hand actions */
.navbar-actions {
  display: flex;
  align-items: center;
  justify-self: end;
  gap: var(--space-2);
}

.navbar-auth {
  display: none;
  align-items: center;
  gap: var(--space-2);
}

.navbar-avatar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: none;
  border-radius: var(--radius-full);
  background: transparent;
  cursor: pointer;
  transition: opacity var(--dur-fast) var(--ease-standard);
}

.navbar-avatar-btn:active {
  opacity: 0.7;
}

.navbar-menu-btn {
  display: inline-flex;
}

/* Mobile menu: a full-screen frosted sheet under the navbar.
 * Portalled to <body>, so it sits just below the navbar (z-index 100) and the
 * close button stays in reach. Motion is short (~180ms) so it feels instant.
 */
.navbar-panel {
  --menu-dur: 180ms;

  position: fixed;
  inset: 0;
  z-index: 99;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: calc(54px + var(--space-5)) var(--gutter) calc(var(--space-8) + env(safe-area-inset-bottom));
  box-sizing: border-box;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: saturate(170%) blur(14px);
  -webkit-backdrop-filter: saturate(170%) blur(14px);
  opacity: 0;
  visibility: hidden;
  transition:
    opacity var(--menu-dur) var(--ease-standard),
    visibility 0s linear var(--menu-dur);
}

@supports not (backdrop-filter: blur(20px)) {
  .navbar-panel {
    background: rgba(255, 255, 255, 0.97);
  }
}

.navbar-panel.is-open {
  opacity: 1;
  visibility: visible;
  transition:
    opacity var(--menu-dur) var(--ease-standard),
    visibility 0s linear 0s;
}

.navbar-panel-list {
  width: 100%;
}

/* Rows rise in with a tiny stagger; they reset instantly on close. */
.navbar-panel-list > li,
.navbar-panel .navbar-panel-secondary {
  opacity: 0;
  transform: translateY(8px);
  transition:
    opacity var(--menu-dur) var(--ease-standard),
    transform var(--menu-dur) var(--ease-standard);
}

.navbar-panel.is-open .navbar-panel-list > li,
.navbar-panel.is-open .navbar-panel-secondary {
  opacity: 1;
  transform: none;
  transition-delay: calc(var(--i, 5) * 22ms);
}

.navbar-panel-list > li + li {
  border-top: 1px solid rgba(40, 26, 34, 0.08);
}

.navbar-panel .navbar-panel-link {
  min-height: 56px;
  gap: var(--space-3);
  border-bottom: 0;
}

.navbar-panel .navbar-panel-link .ui-list-label {
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: -0.014em;
}

.navbar-panel a.navbar-panel-link:hover,
.navbar-panel button.navbar-panel-link:hover {
  background: rgba(157, 31, 95, 0.06);
}

.navbar-panel .navbar-panel-link svg {
  flex: none;
  color: var(--primary);
}

.navbar-panel .navbar-panel-link[aria-current='page'] .ui-list-label {
  color: var(--primary);
  font-weight: 700;
}

/* Small brand dot beside the current page. */
.navbar-panel .navbar-panel-link[aria-current='page']::after {
  content: '';
  width: 7px;
  height: 7px;
  margin-left: auto;
  border-radius: var(--radius-full);
  background: var(--primary);
}

.navbar-panel .navbar-panel-secondary {
  margin-top: var(--space-2);
  border-top: 1px solid rgba(40, 26, 34, 0.12);
  border-radius: 0;
  padding-top: var(--space-3);
  padding-bottom: var(--space-3);
}

.navbar-panel .navbar-panel-secondary .ui-list-label {
  font-size: 0.9375rem;
  color: var(--text-secondary);
}

.navbar-panel-auth {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: 100%;
}

@media (min-width: 1024px) {
  .navbar-nav {
    display: flex;
  }

  .navbar-auth {
    display: flex;
  }

  .navbar-actions .navbar-menu-btn,
  .navbar-panel {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .navbar-panel,
  .navbar-panel-list > li,
  .navbar-panel .navbar-panel-secondary,
  .nav-link,
  .navbar-avatar-btn {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;EAC/B;;yDAEuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,uBAAuB;EACvB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE;AACF;EACE,iBAAiB;;EAEjB,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qGAAqG;EACrG,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,0CAA0C;EAC1C,kDAAkD;EAClD,UAAU;EACV,kBAAkB;EAClB;;wCAEsC;AACxC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB;;2BAEyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA,qEAAqE;AACrE;;EAEE,UAAU;EACV,0BAA0B;EAC1B;;kDAEgD;AAClD;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;;;;;IAKE,gBAAgB;EAClB;AACF","sourcesContent":["/* Navbar\n  Layout only. Tokens and ui-* classes come from siteShell.css. \n*/\n\n.navbar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: rgba(255, 255, 255, 0.86);\n  backdrop-filter: saturate(180%) blur(12px);\n  -webkit-backdrop-filter: saturate(180%) blur(12px);\n  border-bottom: 1px solid var(--border);\n}\n\n@supports not (backdrop-filter: blur(12px)) {\n  .navbar {\n    background: var(--bg);\n  }\n}\n\n.navbar-inner {\n  position: relative;\n  width: 100%;\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 0 var(--gutter);\n  min-height: 54px;\n  box-sizing: border-box;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: var(--space-4);\n}\n\n/* Logo */\n.navbar-logo {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  min-height: 40px;\n  color: var(--primary);\n  text-decoration: none;\n}\n\n.navbar-logo-img {\n  width: 30px;\n  height: 30px;\n  display: block;\n}\n\n.navbar-logo-text {\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.018em;\n  white-space: nowrap;\n}\n\n/* Desktop navigation */\n.navbar-nav {\n  display: none;\n  justify-content: center;\n  align-items: center;\n  gap: var(--space-2);\n  min-width: 0;\n}\n\n.nav-link {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  min-height: 34px;\n  padding: 6px 11px;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--text-secondary);\n  text-decoration: none;\n  white-space: nowrap;\n  border-radius: var(--radius-sm);\n  transition:\n    color var(--dur-fast) var(--ease-standard),\n    background-color var(--dur-fast) var(--ease-standard);\n}\n\n.nav-link:hover {\n  color: var(--text-primary);\n  background: var(--bg-secondary);\n}\n\n.nav-link.is-active,\n.nav-link[aria-current='page'] {\n  font-weight: 700;\n  color: var(--primary);\n  background: var(--surface-brand-wash);\n}\n\n/* Right-hand actions */\n.navbar-actions {\n  display: flex;\n  align-items: center;\n  justify-self: end;\n  gap: var(--space-2);\n}\n\n.navbar-auth {\n  display: none;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.navbar-avatar-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  border: none;\n  border-radius: var(--radius-full);\n  background: transparent;\n  cursor: pointer;\n  transition: opacity var(--dur-fast) var(--ease-standard);\n}\n\n.navbar-avatar-btn:active {\n  opacity: 0.7;\n}\n\n.navbar-menu-btn {\n  display: inline-flex;\n}\n\n/* Mobile menu: a full-screen frosted sheet under the navbar.\n * Portalled to <body>, so it sits just below the navbar (z-index 100) and the\n * close button stays in reach. Motion is short (~180ms) so it feels instant.\n */\n.navbar-panel {\n  --menu-dur: 180ms;\n\n  position: fixed;\n  inset: 0;\n  z-index: 99;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n  padding: calc(54px + var(--space-5)) var(--gutter) calc(var(--space-8) + env(safe-area-inset-bottom));\n  box-sizing: border-box;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  background: rgba(255, 255, 255, 0.6);\n  backdrop-filter: saturate(170%) blur(14px);\n  -webkit-backdrop-filter: saturate(170%) blur(14px);\n  opacity: 0;\n  visibility: hidden;\n  transition:\n    opacity var(--menu-dur) var(--ease-standard),\n    visibility 0s linear var(--menu-dur);\n}\n\n@supports not (backdrop-filter: blur(20px)) {\n  .navbar-panel {\n    background: rgba(255, 255, 255, 0.97);\n  }\n}\n\n.navbar-panel.is-open {\n  opacity: 1;\n  visibility: visible;\n  transition:\n    opacity var(--menu-dur) var(--ease-standard),\n    visibility 0s linear 0s;\n}\n\n.navbar-panel-list {\n  width: 100%;\n}\n\n/* Rows rise in with a tiny stagger; they reset instantly on close. */\n.navbar-panel-list > li,\n.navbar-panel .navbar-panel-secondary {\n  opacity: 0;\n  transform: translateY(8px);\n  transition:\n    opacity var(--menu-dur) var(--ease-standard),\n    transform var(--menu-dur) var(--ease-standard);\n}\n\n.navbar-panel.is-open .navbar-panel-list > li,\n.navbar-panel.is-open .navbar-panel-secondary {\n  opacity: 1;\n  transform: none;\n  transition-delay: calc(var(--i, 5) * 22ms);\n}\n\n.navbar-panel-list > li + li {\n  border-top: 1px solid rgba(40, 26, 34, 0.08);\n}\n\n.navbar-panel .navbar-panel-link {\n  min-height: 56px;\n  gap: var(--space-3);\n  border-bottom: 0;\n}\n\n.navbar-panel .navbar-panel-link .ui-list-label {\n  font-size: 1.25rem;\n  font-weight: 600;\n  letter-spacing: -0.014em;\n}\n\n.navbar-panel a.navbar-panel-link:hover,\n.navbar-panel button.navbar-panel-link:hover {\n  background: rgba(157, 31, 95, 0.06);\n}\n\n.navbar-panel .navbar-panel-link svg {\n  flex: none;\n  color: var(--primary);\n}\n\n.navbar-panel .navbar-panel-link[aria-current='page'] .ui-list-label {\n  color: var(--primary);\n  font-weight: 700;\n}\n\n/* Small brand dot beside the current page. */\n.navbar-panel .navbar-panel-link[aria-current='page']::after {\n  content: '';\n  width: 7px;\n  height: 7px;\n  margin-left: auto;\n  border-radius: var(--radius-full);\n  background: var(--primary);\n}\n\n.navbar-panel .navbar-panel-secondary {\n  margin-top: var(--space-2);\n  border-top: 1px solid rgba(40, 26, 34, 0.12);\n  border-radius: 0;\n  padding-top: var(--space-3);\n  padding-bottom: var(--space-3);\n}\n\n.navbar-panel .navbar-panel-secondary .ui-list-label {\n  font-size: 0.9375rem;\n  color: var(--text-secondary);\n}\n\n.navbar-panel-auth {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  width: 100%;\n}\n\n@media (min-width: 1024px) {\n  .navbar-nav {\n    display: flex;\n  }\n\n  .navbar-auth {\n    display: flex;\n  }\n\n  .navbar-actions .navbar-menu-btn,\n  .navbar-panel {\n    display: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .navbar-panel,\n  .navbar-panel-list > li,\n  .navbar-panel .navbar-panel-secondary,\n  .nav-link,\n  .navbar-avatar-btn {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
